// import React, { useState, useEffect } from "react";
// import { GiCrossedBones } from "react-icons/gi";
// import { LuSave } from "react-icons/lu";
// import { themeMasterSchema } from "../../../../utils/Validation/Schemas";
// import PreviewModal from "./PreviewModal"; 

// const AddThemeMaster = () => {
//   const [form, setForm] = useState({
//     report_title: "",
//     subtitle: "",
//     address: "",
//     pin_code: "",
//     landmark: "",
//     mobile: "",
//     email: "",
//     website: "",
//     logo_align: "Left",
//   });

//   const [logoFile, setLogoFile] = useState(null);
//   const [letterFile, setLetterFile] = useState(null);

//   const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
//   const [letterPreviewUrl, setLetterPreviewUrl] = useState(null);

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // preview modal state
//   const [showPreview, setShowPreview] = useState(false);

//   const API_BASE = "http://localhost:3001";

//   // cleanup previews
//   useEffect(() => {
//     return () => {
//       [logoPreviewUrl, letterPreviewUrl].forEach((url) => {
//         if (url) URL.revokeObjectURL(url);
//       });
//     };
//   }, [logoPreviewUrl, letterPreviewUrl]);

//   // validate full form
//   async function validateForm() {
//     try {
//       await themeMasterSchema.validate(form, { abortEarly: false });
//       return { valid: true, errors: {} };
//     } catch (err) {
//       const newErrors = {};
//       if (err.inner) {
//         err.inner.forEach((e) => {
//           if (e.path) newErrors[e.path] = e.message;
//         });
//       }
//       return { valid: false, errors: newErrors };
//     }
//   }

//   // it will update field & validate single field
//   function setField(name, value) {
//     setForm((p) => ({ ...p, [name]: value }));
//     themeMasterSchema
//       .validateAt(name, { ...form, [name]: value })
//       .then(() => {
//         setErrors((prev) => {
//           const copy = { ...prev };
//           delete copy[name];
//           return copy;
//         });
//       })
//       .catch((err) => {
//         setErrors((prev) => ({ ...prev, [name]: err.message }));
//       });
//   }

//   // handle file selection
//   function handleFileSelect(e, setter, setPreviewState) {
//     const f = e.target.files?.[0] || null;

//     setPreviewState((prev) => {
//       if (prev) URL.revokeObjectURL(prev);
//       return null;
//     });

//     if (f) {
//       const obj = URL.createObjectURL(f);
//       setPreviewState(obj);
//     }

//     setter(f);
//   }

//   const allowOnlyNumbers = (e) => {
//     const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//     if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
//       e.preventDefault();
//     }
//   };

//   // Save handler
//   async function handleSave(e) {
//     e.preventDefault();

//     const validation = await validateForm();
//     setErrors(validation.errors);

//     if (!validation.valid) {
//       alert("Please fix validation errors before saving.");
//       return;
//     }

//     // Ensure only one upload mode
//     if (logoFile && letterFile) {
//       setErrors((prev) => ({
//         ...prev,
//         global: "Please upload either a logo or a letterhead, not both.",
//       }));
//       return;
//     }

//     if (!logoFile && !letterFile) {
//       setErrors((prev) => ({
//         ...prev,
//         global: "Please upload a logo or a letterhead.",
//       }));
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const fd = new FormData();

//       if (letterFile) {
//         fd.append("letterhead", letterFile);
//       } else {
//         Object.keys(form).forEach((k) => fd.append(k, form[k] ?? ""));
//         if (logoFile) fd.append("logo", logoFile);
//       }

//       const resp = await fetch(`${API_BASE}/api/admin/theme`, {
//         method: "POST",
//         body: fd,
//       });

//       const data = await resp.json();
//       if (resp.ok) {
//         alert("Saved successfully (id: " + data.id + ")");
//         resetForm();
//       } else {
//         alert("Save failed: " + (data.error || data.message || JSON.stringify(data)));
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network or server error: " + err.message);
//     } finally {
//       setIsSubmitting(false);
//     }
//   }

//   function resetForm() {
//     setForm({
//       report_title: "",
//       subtitle: "",
//       address: "",
//       pin_code: "",
//       landmark: "",
//       mobile: "",
//       email: "",
//       website: "",
//       logo_align: "Left",
//     });

//     [logoPreviewUrl, letterPreviewUrl].forEach((url) => {
//       if (url) URL.revokeObjectURL(url);
//     });

//     setLogoFile(null);
//     setLetterFile(null);
//     setLogoPreviewUrl(null);
//     setLetterPreviewUrl(null);
//     setErrors({});
//   }

//   return (
//     <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc", width: "100%", overflowX: "hidden" }}>
//       <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
//         <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
//           Theme Master
//         </h5>

//         <form onSubmit={handleSave} noValidate>
          
//           <div className="row">
//             <div className="col-lg-8 col-12 mb-3">
//               <label className="form-label">
//                 Report Title Or Company Name <span className="text-danger">*</span>
//               </label>
//               <input
//                 name="report_title"
//                 value={form.report_title}
//                 onChange={(e) => setField("report_title", e.target.value)}
//                 className="form-control custom-shadow"
//                 required
//                 aria-required="true"
//               />
//               {errors.report_title && <div className="text-danger mt-1">{errors.report_title}</div>}
//             </div>


//             <div className="col-lg-4 col-12 mb-3">
//               <label className="form-label">Sub Title or Business Caption</label>
//               <input
//                 name="subtitle"
//                 value={form.subtitle}
//                 onChange={(e) => setField("subtitle", e.target.value)}
//                 className="form-control custom-shadow"
//               />
//             </div>
//           </div>

//           {/* Address */}
//           <div className="row">
//             <div className="col-12 mb-3">
//               <label className="form-label">Address</label>a
//               <textarea
//                 name="address"
//                 value={form.address}
//                 onChange={(e) => setField("address", e.target.value)}
//                 className="form-control custom-shadow"
//                 rows={3}
//               />
//               {errors.address && <div className="text-danger mt-1">{errors.address}</div>}
//             </div>
//           </div>

//           {/* Pin + Landmark */}
//           <div className="row">
//             <div className="col-md-4 mb-3">
//               <label className="form-label">Pin Code</label>
//               <input
//                 name="pin_code"
//                 value={form.pin_code}
//                 onChange={(e) => setField("pin_code", e.target.value)}
//                 onKeyDown={allowOnlyNumbers}
//                 className="form-control custom-shadow"
//                 maxLength={10}
//               />
//               {errors.pin_code && <div className="text-danger mt-1">{errors.pin_code}</div>}
//             </div>

//             <div className="col-md-8 mb-3">
//               <label className="form-label">Landmark</label>
//               <input
//                 name="landmark"
//                 value={form.landmark}
//                 onChange={(e) => setField("landmark", e.target.value)}
//                 className="form-control custom-shadow"
//               />
//             </div>
//           </div>

//           {/* Mobile / Email / Website */}
//           <div className="row">
//             <div className="col-md-4 mb-3">
//               <label className="form-label">Mobile</label>
//               <input
//                 name="mobile"
//                 value={form.mobile}
//                 onChange={(e) => setField("mobile", e.target.value)}
//                 onKeyDown={allowOnlyNumbers}
//                 className="form-control custom-shadow"
//                 maxLength={10}
//               />
//               {errors.mobile && <div className="text-danger mt-1">{errors.mobile}</div>}
//             </div>

//             <div className="col-md-4 mb-3">
//               <label className="form-label">Email</label>
//               <input
//                 name="email"
//                 value={form.email}
//                 onChange={(e) => setField("email", e.target.value)}
//                 className="form-control custom-shadow"
//               />
//               {errors.email && <div className="text-danger mt-1">{errors.email}</div>}
//             </div>

//             <div className="col-md-4 mb-3">
//               <label className="form-label">Website</label>
//               <input
//                 name="website"
//                 value={form.website}
//                 onChange={(e) => setField("website", e.target.value)}
//                 className="form-control custom-shadow"
//               />
//               {errors.website && <div className="text-danger mt-1">{errors.website}</div>}
//             </div>
//           </div>

//           {/* Company Logo */}
//           <div className="row">
//             <div className="col-12 mb-3">
//               <label className="form-label">Company Logo</label>
//               <div className="d-flex align-items-start gap-3">
//                 <div className="custom-shadow" style={{ width: 110, height: 84, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" }}>
//                   {logoPreviewUrl ? (
//                     <img src={logoPreviewUrl} alt="logo" style={{ maxWidth: "100%", maxHeight: "100%" }} />
//                   ) : (
//                     <svg width="84" height="64" viewBox="0 0 120 80">
//                       <rect x="2" y="2" width="116" height="76" rx="3" fill="#fff" stroke="#111" strokeWidth="3" />
//                       <polyline points="10,64 42,26 72,56 110,18" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
//                       <circle cx="18" cy="18" r="4" fill="#111" />
//                     </svg>
//                   )}
//                 </div>

//                 <div style={{ flex: 1 }}>
//                   <div className="d-flex gap-2 mb-2">
//                     {["Left", "Right", "None"].map((p) => (
//                       <button
//                         key={p}
//                         type="button"
//                         onClick={() => setField("logo_align", p)}
//                         className={`toggle-btn ${form.logo_align === p ? "active" : ""}`}
//                       >
//                         {p}
//                       </button>
//                     ))}
//                   </div>

//                   <div>
//                     <input type="file" accept="image/*" onChange={(e) => handleFileSelect(e, setLogoFile, setLogoPreviewUrl)} />
//                   </div>
//                 </div>
//               </div>
//               {errors.logo_align && <div className="text-danger mt-1">{errors.logo_align}</div>}
//             </div>
//           </div>

//           {/* Divider */}
//           <div className="row">
//             <div className="col-12 mb-3 d-flex align-items-center">
//               <div style={{ flex: 1, height: 1, background: "#d9d9d9" }} />
//               <div style={{ padding: "8px 16px", margin: "0 12px", borderRadius: 8, background: "#e84a18", color: "#fff", fontWeight: 700 }}>Or</div>
//               <div style={{ flex: 1, height: 1, background: "#d9d9d9" }} />
//             </div>
//           </div>

//           {/* Letterhead */}
//           <div className="row">
//             <div className="col-12 mb-3">
//               <label className="form-label">Letterhead Image</label>
//               <div className="d-flex align-items-start gap-3">
//                 <div className="custom-shadow" style={{ width: 110, height: 84, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" }}>
//                   {letterPreviewUrl ? (
//                     <img src={letterPreviewUrl} alt="letter" style={{ maxWidth: "100%", maxHeight: "100%" }} />
//                   ) : (
//                     <svg width="84" height="64" viewBox="0 0 120 80">
//                       <rect x="2" y="2" width="116" height="76" rx="3" fill="#fff" stroke="#111" strokeWidth="3" />
//                       <polyline points="10,64 42,26 72,56 110,18" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
//                       <circle cx="18" cy="18" r="4" fill="#111" />
//                     </svg>
//                   )}
//                 </div>

//                 <div style={{ marginTop: 8 }}>
//                   <input type="file" accept="image/*" onChange={(e) => handleFileSelect(e, setLetterFile, setLetterPreviewUrl)} />
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Buttons */}
//           <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
//             <button
//               type="button"
//               className="previewButton d-flex align-items-center px-4"
//               onClick={() => setShowPreview(true)}
//             >
//               <span className="d-none d-md-inline me-2">👁</span> Preview
//             </button>

//             <button
//               type="submit"
//               className="saveButton d-flex align-items-center px-4"
//               disabled={isSubmitting}
//             >
//               <LuSave className="d-none d-md-inline me-2" />
//               {isSubmitting ? "Saving..." : "Save"}
//             </button>

//             <button
//               type="button"
//               className="backButton d-flex align-items-center px-4"
//               onClick={() => window.history.back()}
//             >
//               <GiCrossedBones className="d-none d-md-inline me-2" /> Cancel
//             </button>
//           </div>

//           {errors.global && <div className="text-danger mt-3 text-center">{errors.global}</div>}
//         </form>
//       </div>

//       {/* Preview modal (separate component) */}
//       <PreviewModal
//         open={showPreview}
//         onClose={() => setShowPreview(false)}
//         form={form}
//         logoPreviewUrl={logoPreviewUrl}
//         letterPreviewUrl={letterPreviewUrl}
//       />
//     </div>
//   );
// };

// export default AddThemeMaster;



import React, { useState, useEffect, useRef } from "react";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import { themeMasterSchema } from "../../../../utils/Validation/Schemas";
import PreviewModal from "./PreviewModal";
import { useThemeOperations } from "../../../../services/redux/api/components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddThemeMaster = () => {
  const [form, setForm] = useState({
    report_title: "",
    subtitle: "",
    address: "",
    pin_code: "",
    landmark: "",
    mobile: "",
    email: "",
    website: "",
    logo_align: "Left",
  });

  const [logoFile, setLogoFile] = useState(null);
  const [letterFile, setLetterFile] = useState(null);

  const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
  const [letterPreviewUrl, setLetterPreviewUrl] = useState(null);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showPreview, setShowPreview] = useState(false);

  // refs for file inputs so we can clear them programmatically
  const logoInputRef = useRef(null);
  const letterInputRef = useRef(null);

  // RTK Query mutation hook
  const { createOrUpdateTheme, isProcessing } = useThemeOperations();

  // cleanup previews on unmount
  useEffect(() => {
    return () => {
      [logoPreviewUrl, letterPreviewUrl].forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [logoPreviewUrl, letterPreviewUrl]);

  async function validateForm() {
    try {
      await themeMasterSchema.validate(form, { abortEarly: false });
      return { valid: true, errors: {} };
    } catch (err) {
      const newErrors = {};
      if (err.inner) {
        err.inner.forEach((e) => {
          if (e.path) newErrors[e.path] = e.message;
        });
      }
      return { valid: false, errors: newErrors };
    }
  }

  function setField(name, value) {
    setForm((p) => ({ ...p, [name]: value }));
    themeMasterSchema
      .validateAt(name, { ...form, [name]: value })
      .then(() => {
        setErrors((prev) => {
          const copy = { ...prev };
          delete copy[name];
          return copy;
        });
      })
      .catch((err) => {
        setErrors((prev) => ({ ...prev, [name]: err.message }));
      });
  }

  function handleFileSelect(e, setter, setPreviewState) {
    const f = e.target.files?.[0] || null;

    setPreviewState((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return null;
    });

    if (f) {
      const obj = URL.createObjectURL(f);
      setPreviewState(obj);
    }

    setter(f);
  }

  const allowOnlyNumbers = (e) => {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
      e.preventDefault();
    }
  };

  // Reset form state + file inputs + previews + errors
  function resetForm() {
    setForm({
      report_title: "",
      subtitle: "",
      address: "",
      pin_code: "",
      landmark: "",
      mobile: "",
      email: "",
      website: "",
      logo_align: "Left",
    });

    // revoke URLs
    [logoPreviewUrl, letterPreviewUrl].forEach((url) => {
      if (url) URL.revokeObjectURL(url);
    });

    // clear file states
    setLogoFile(null);
    setLetterFile(null);
    setLogoPreviewUrl(null);
    setLetterPreviewUrl(null);

    // clear actual file input elements (if refs present)
    try {
      if (logoInputRef.current) logoInputRef.current.value = null;
      if (letterInputRef.current) letterInputRef.current.value = null;
    } catch (e) {
      // ignore
    }

    setErrors({});
    setShowPreview(false);
  }

  // Cancel: reset form (do NOT redirect)
  function handleCancel() {
    resetForm();
    toast.info("Form reset", { position: "top-right", autoClose: 2000 });
  }

  // Save handler integrated with RTK Query and toastify
  async function handleSave(e) {
    e.preventDefault();

    // Ensure only one upload mode
    if (logoFile && letterFile) {
      setErrors((prev) => ({
        ...prev,
        global: "Please upload either a logo or a letterhead, not both.",
      }));
      toast.error("Please upload either a logo or a letterhead, not both.");
      return;
    }

    const uploadingLetterOnly = !!letterFile;

    if (!uploadingLetterOnly) {
      // validate entire form only when not uploading letterhead
      const validation = await validateForm();
      setErrors(validation.errors);

      if (!validation.valid) {
        toast.error("Please fix validation errors before saving.");
        return;
      }
    }

    if (!logoFile && !letterFile) {
      setErrors((prev) => ({
        ...prev,
        global: "Please upload a logo or a letterhead.",
      }));
      toast.error("Please upload a logo or a letterhead.");
      return;
    }

    setIsSubmitting(true);
    try {
      const fd = new FormData();

      if (uploadingLetterOnly) {
        fd.append("letterhead", letterFile);
        fd.append("Mode", "LETTER_ONLY");
      } else {
        Object.keys(form).forEach((k) => fd.append(k, form[k] ?? ""));
        if (logoFile) fd.append("logo", logoFile);
        fd.append("Mode", "CREATE"); // adjust to 'UPDATE' + ThemeID when editing
      }

      const response = await createOrUpdateTheme(fd).unwrap();

      // controller returns { success: true/false, message, data }
      if (response && (response.success || response.Status === "SUCCESS")) {
        const returnedId =
          (response.data && (response.data.ThemeID || response.data.ThemeId || response.data.id)) || null;
        toast.success("Saved successfully" + (returnedId ? ` (id: ${returnedId})` : ""), {
          position: "top-right",
          autoClose: 2500,
        });
        resetForm();
      } else {
        const msg = response?.message || response?.Message || JSON.stringify(response);
        toast.error("Save failed: " + msg, { position: "top-right", autoClose: 4000 });
      }
    } catch (err) {
      const msg =
        (err && err.data && (err.data.message || err.data.Message)) ||
        err?.message ||
        "Network or server error";
      console.error("createOrUpdateTheme error:", err);
      toast.error("Save failed: " + msg, { position: "top-right", autoClose: 4000 });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc", width: "100%", overflowX: "hidden" }}>
      {/* Toast container ensures toasts show even if not added globally */}
      <ToastContainer />

      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Theme Master</h5>

        <form onSubmit={handleSave} noValidate>
          <div className="row">
            <div className="col-lg-8 col-12 mb-3">
              <label className="form-label">
                Report Title Or Company Name <span className="text-danger">*</span>
              </label>
              <input
                name="report_title"
                value={form.report_title}
                onChange={(e) => setField("report_title", e.target.value)}
                className="form-control custom-shadow"
                required
                aria-required="true"
              />
              {errors.report_title && <div className="text-danger mt-1">{errors.report_title}</div>}
            </div>

            <div className="col-lg-4 col-12 mb-3">
              <label className="form-label">Sub Title or Business Caption</label>
              <input
                name="subtitle"
                value={form.subtitle}
                onChange={(e) => setField("subtitle", e.target.value)}
                className="form-control custom-shadow"
              />
            </div>
          </div>

          {/* Address */}
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">Address</label>
              <textarea
                name="address"
                value={form.address}
                onChange={(e) => setField("address", e.target.value)}
                className="form-control custom-shadow"
                rows={3}
              />
              {errors.address && <div className="text-danger mt-1">{errors.address}</div>}
            </div>
          </div>

          {/* Pin + Landmark */}
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Pin Code</label>
              <input
                name="pin_code"
                value={form.pin_code}
                onChange={(e) => setField("pin_code", e.target.value)}
                onKeyDown={allowOnlyNumbers}
                className="form-control custom-shadow"
                maxLength={10}
              />
              {errors.pin_code && <div className="text-danger mt-1">{errors.pin_code}</div>}
            </div>

            <div className="col-md-8 mb-3">
              <label className="form-label">Landmark</label>
              <input
                name="landmark"
                value={form.landmark}
                onChange={(e) => setField("landmark", e.target.value)}
                className="form-control custom-shadow"
              />
            </div>
          </div>

          {/* Mobile / Email / Website */}
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Mobile</label>
              <input
                name="mobile"
                value={form.mobile}
                onChange={(e) => setField("mobile", e.target.value)}
                onKeyDown={allowOnlyNumbers}
                className="form-control custom-shadow"
                maxLength={10}
              />
              {errors.mobile && <div className="text-danger mt-1">{errors.mobile}</div>}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Email</label>
              <input
                name="email"
                value={form.email}
                onChange={(e) => setField("email", e.target.value)}
                className="form-control custom-shadow"
              />
              {errors.email && <div className="text-danger mt-1">{errors.email}</div>}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Website</label>
              <input
                name="website"
                value={form.website}
                onChange={(e) => setField("website", e.target.value)}
                className="form-control custom-shadow"
              />
              {errors.website && <div className="text-danger mt-1">{errors.website}</div>}
            </div>
          </div>

          {/* Company Logo */}
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">Company Logo</label>
              <div className="d-flex align-items-start gap-3">
                <div className="custom-shadow" style={{ width: 110, height: 84, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" }}>
                  {logoPreviewUrl ? (
                    <img src={logoPreviewUrl} alt="logo" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                  ) : (
                    <svg width="84" height="64" viewBox="0 0 120 80">
                      <rect x="2" y="2" width="116" height="76" rx="3" fill="#fff" stroke="#111" strokeWidth="3" />
                      <polyline points="10,64 42,26 72,56 110,18" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
                      <circle cx="18" cy="18" r="4" fill="#111" />
                    </svg>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <div className="d-flex gap-2 mb-2">
                    {["Left", "Right", "None"].map((p) => (
                      <button
                        key={p}
                        type="button"
                        onClick={() => setField("logo_align", p)}
                        className={`toggle-btn ${form.logo_align === p ? "active" : ""}`}
                      >
                        {p}
                      </button>
                    ))}
                  </div>

                  <div>
                    <input
                      ref={logoInputRef}
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileSelect(e, setLogoFile, setLogoPreviewUrl)}
                    />
                  </div>
                </div>
              </div>
              {errors.logo_align && <div className="text-danger mt-1">{errors.logo_align}</div>}
            </div>
          </div>

          {/* Divider */}
          <div className="row">
            <div className="col-12 mb-3 d-flex align-items-center">
              <div style={{ flex: 1, height: 1, background: "#d9d9d9" }} />
              <div style={{ padding: "8px 16px", margin: "0 12px", borderRadius: 8, background: "#e84a18", color: "#fff", fontWeight: 700 }}>Or</div>
              <div style={{ flex: 1, height: 1, background: "#d9d9d9" }} />
            </div>
          </div>

          {/* Letterhead */}
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">Letterhead Image</label>
              <div className="d-flex align-items-start gap-3">
                <div className="custom-shadow" style={{ width: 110, height: 84, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" }}>
                  {letterPreviewUrl ? (
                    <img src={letterPreviewUrl} alt="letter" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                  ) : (
                    <svg width="84" height="64" viewBox="0 0 120 80">
                      <rect x="2" y="2" width="116" height="76" rx="3" fill="#fff" stroke="#111" strokeWidth="3" />
                      <polyline points="10,64 42,26 72,56 110,18" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
                      <circle cx="18" cy="18" r="4" fill="#111" />
                    </svg>
                  )}
                </div>

                <div style={{ marginTop: 8 }}>
                  <input
                    ref={letterInputRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileSelect(e, setLetterFile, setLetterPreviewUrl)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
            <button
              type="button"
              className="previewButton d-flex align-items-center px-4"
              onClick={() => setShowPreview(true)}
            >
              <span className="d-none d-md-inline me-2">👁</span> Preview
            </button>

            <button
              type="submit"
              className="saveButton d-flex align-items-center px-4"
              disabled={isSubmitting || isProcessing}
            >
              <LuSave className="d-none d-md-inline me-2" />
              {isSubmitting || isProcessing ? "Saving..." : "Save"}
            </button>

            <button
              type="button"
              className="backButton d-flex align-items-center px-4"
              onClick={handleCancel}
            >
              <GiCrossedBones className="d-none d-md-inline me-2" /> Cancel
            </button>
          </div>

          {errors.global && <div className="text-danger mt-3 text-center">{errors.global}</div>}
        </form>
      </div>

      {/* Preview modal (separate component) */}
      <PreviewModal
        open={showPreview}
        onClose={() => setShowPreview(false)}
        form={form}
        logoPreviewUrl={logoPreviewUrl}
        letterPreviewUrl={letterPreviewUrl}
      />
    </div>
  );
};

export default AddThemeMaster;



